<template>
	<div class="page-checkout-confirm" style="margin-top: 300px">
		<div class="vertical-center">
			<div class="text-center">
				<h1>Thank you!</h1>
				<h5>
					Order Placed Successfully. Your order ID is : {{ getPlacedOrderId }}
				</h5>
				<a href="/orders" class="thank-you-back">My Orders</a>
			</div>
		</div>
	</div>
	<Footer />
</template>

<script>
	import {mapGetters} from "vuex";
	import Footer from "../components/Bottom/Footer.vue";
	export default {
		computed: {...mapGetters("orders", ["getPlacedOrderId"])},
		components: {Footer},
		mounted() {
			// if(!this.getPlacedOrderId){
			//   this.$router.push({name : 'Home'})
			// }
		},
	};
</script>

<style></style>
